import { render, staticRenderFns } from "./the-records.vue?vue&type=template&id=6c29bab6&scoped=true&"
import script from "./the-records.vue?vue&type=script&lang=js&"
export * from "./the-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c29bab6",
  null
  
)

export default component.exports